import EkgRecording from './EkgRecording'

export default EkgRecording



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecording/index.js